// extracted by mini-css-extract-plugin
module.exports = {"custom-badge":"badgeSkydropx_custom-badge__f53zX","custom-badge-container":"badgeSkydropx_custom-badge-container__b6Nh2"};